import * as React from 'react';
import Popover from '@mui/material/Popover';
import { Box, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles';
import { useNavigate } from 'react-router-dom';
import ChangePermissionAccordion from '../ChangePermissionAccordion/ChangePermissionAccordion';
import { useAuth } from 'context/AuthContext';
import { snackbarService } from 'services/snackbarService';
import RevokeUserButton from '../RevokeUserButton/RevokeUserButton';

interface Props {
  doctorId: number;
  doctorName: string;
}

export default function UserOptions({ doctorId, doctorName }: Props) {
  const { user } = useAuth();
  const globalStyles = useGlobalStyles();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);



  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>

      <IconButton onClick={handleClick}>
        <MoreVertIcon sx={{ color: colors.secondary }} />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '10px',
            overflow: 'hidden',
            maxWidth: '200px'
          }}
          p={1}
        >
          <ChangePermissionAccordion
            doctorId={doctorId}
            onClose={() => setAnchorEl(null)}
          />

          <RevokeUserButton
            userId={doctorId}
            userName={doctorName}
          />
        </Box>
      </Popover>
    </div>
  );
}
